package component.ability

import abilities.*
import com.github.quillraven.fleks.*
import com.soywiz.korge.view.*
import component.*
import org.jbox2d.common.*
import org.jbox2d.dynamics.*

class AbilityComponent(
    val ability: Abilities,
    val body: Body,
    val view: View,
    val direction: Vec2,
    // todo replace by common type
    val fireBolt: FireBolt
) : Component<AbilityComponent> {

    override fun type() = AbilityComponent

    companion object : ComponentType<AbilityComponent>()
}
